import LinkApi from '../constants/linkApi';
import BaseApi from './Base';

export default class LoginApi extends BaseApi {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);
    }
    postLogin(params) {
        const url = LinkApi.LOGIN.AUTH;
        return this.axios.post(url, params);
    };
    postLoginCheck(params) {
        const url = LinkApi.LOGIN.CHECK;
        return this.axios.post(url, params);
    }
    postLogout(params) {
        const url = LinkApi.LOGIN.LOGOUT;
        return this.axios.post(url, params);
    }
}